import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Communication = () => (
  <div className="service-page">
    <Navbar />
    <div className="service-hero">
      <h1>Communication Integration</h1>
      <p>Enterprise-grade communication channels at scale — email, SMS, and WhatsApp messaging solutions built for high‑volume, global delivery.</p>
    </div>

    <div className="service-content">
      <div className="service-grid">
        <div className="service-card">
          <div className="icon">📧</div>
          <h2>Email at Scale</h2>
          <p>
            Send millions of transactional and marketing emails with enterprise-grade deliverability.
            Our platform handles everything from simple notifications to complex multi-tenant campaigns
            with full visibility into every message.
          </p>
          <ul>
            <li>Bulk transactional &amp; marketing email sending</li>
            <li>Advanced deliverability (SPF, DKIM, DMARC, custom IP pools)</li>
            <li>Rich HTML templating engine with dynamic variables</li>
            <li>Real-time open, click, bounce &amp; complaint tracking</li>
            <li>Automated bounce handling &amp; suppression lists</li>
            <li>Webhook &amp; REST API integration</li>
            <li>Dedicated SMTP relays &amp; sub-accounts</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">📱</div>
          <h2>Global SMS Messaging</h2>
          <p>
            Reach customers instantly in over 200 countries and territories with our direct-to-carrier
            SMS network. Designed for reliability, compliance, and speed at any volume.
          </p>
          <ul>
            <li>Coverage in 200+ countries with local sender IDs</li>
            <li>Custom alphanumeric &amp; short-code sender IDs</li>
            <li>Automated retry logic with smart routing</li>
            <li>Delivery receipts (DLR) &amp; real-time status callbacks</li>
            <li>Two-way SMS for interactive conversations</li>
            <li>Regulatory compliance (GDPR, TCPA, local opt-out rules)</li>
            <li>High throughput — up to 10 000 SMS/second</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">💬</div>
          <h2>WhatsApp API Integration</h2>
          <p>
            Engage customers where they are. Our WhatsApp Business API solution enables secure,
            two-way communication at scale — from automated notifications to rich media support
            conversations.
          </p>
          <ul>
            <li>Official WhatsApp Business API (BSP) connectivity</li>
            <li>OTP &amp; authentication message delivery</li>
            <li>Rich media support (images, documents, audio, video)</li>
            <li>Interactive buttons, lists &amp; quick replies</li>
            <li>Session management &amp; 24-hour free-form window</li>
            <li>Pre-approved message templates for proactive outreach</li>
            <li>End-to-end encryption &amp; data privacy compliance</li>
          </ul>
        </div>
      </div>
    </div>

    <div className="service-cta">
      <h2>Ready to scale your communications?</h2>
      <p>Get in touch for a tailored solution that fits your volume, region, and compliance requirements.</p>
      <a href="mailto:kwuimi@qmxtechnology.com" className="cta">Contact Us</a>
    </div>

    <Footer />
  </div>
);

export default Communication;
